var SCREEN_WIDTH = window.innerWidth; // Get the initial screen width
const LARGE_MOBILE_BREAKPOINT = 989; // Define the mobile, ipad portrait breakpoint

// Search input focus in modal
function toggleFocusSearch() {
  const headerSearchInput = document.querySelector('.header-search__input-interface');
  const searchInModalInput = document.getElementById('Search-In-Modal');
  const detailsElement = document.querySelector('.header__search details'); // Adjust the selector if necessary

  if (headerSearchInput && searchInModalInput && detailsElement) {
    headerSearchInput.addEventListener('click', function () {
      // Create a MutationObserver to watch for changes to the details element
      const observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          if (mutation.attributeName === 'open') {
            // Focus the input when the details element is opened
            if (detailsElement.hasAttribute('open')) {
              searchInModalInput.focus();
              // Disconnect the observer once the input is focused
              observer.disconnect();
            }
          }
        });
      });

      // Configure the observer to watch for attribute changes
      observer.observe(detailsElement, { attributes: true });
    });
  }
}

// Mega menu open on hover
function toggleMegaMenuWhenHover() {
  const menuItems = document.querySelectorAll('.header-wrapper .mega-menu');

  if (menuItems) {
    menuItems.forEach(function (item) {
      item.addEventListener('mouseover', function () {
        item.setAttribute('open', true);
      });

      item.addEventListener('click', function () {
        item.setAttribute('open', true);
      });

      item.addEventListener('mouseout', function () {
        item.removeAttribute('open');
      });
    });
  }
}

function addEventForMegaMenuItem() {
  const menuItems = document.querySelectorAll('.header__inline-menu .mega-menu > .header__menu-item');

  if (menuItems) {
    menuItems.forEach(function (item) {
      item.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();

        const href = item.getAttribute('data-href');

        if (href) {
          window.location.href = href;
        }
      });
    });
  }
}

// Update the SCREEN_WIDTH variable when the window is resized
function updateScreenWidth() {
  SCREEN_WIDTH = window.innerWidth;
}

// Handle click event on footer menu
function handleFooterMenuClick(event) {
  if (SCREEN_WIDTH > LARGE_MOBILE_BREAKPOINT) {
    event.preventDefault();
    event.stopPropagation();
  }
}

// Force footer menu to be open and disable click event on on desktop
function forceFooterMenuOpenOnDesktop() {
  const menuList = document.querySelectorAll('.footer-block--menu');

  if (menuList) {
    menuList.forEach(function (menu) {
      const summary = menu.querySelector('summary');

      if (SCREEN_WIDTH > LARGE_MOBILE_BREAKPOINT) {
        menu.setAttribute('open', true);
        summary.addEventListener('click', handleFooterMenuClick);
      } else {
        menu.removeAttribute('open');
        summary.removeEventListener('click', handleFooterMenuClick);
      }
    });
  }
}

// Handle resize event
function handleResize() {
  updateScreenWidth();
  forceFooterMenuOpenOnDesktop();
}

function initProcessBar() {
  setTimeout(() => {
    const processBars = document.querySelectorAll('.process-bar-trigger');

    if (processBars) {
      processBars.forEach((item) => {
        item.style.width = parseFloat(item.dataset['width']) + '%';
      });
    }
  }, 200);
}

function checkIfTotalPriceChange() {
  const miniCartTotalPrice = document.querySelector('#CartDrawer');
  const cartTotalPrice = document.querySelector('#main-cart-footer');
  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.type === 'childList' || mutation.type === 'subtree' || mutation.type === 'attributes') {
        initProcessBar();
      }
    });
  });

  observer.observe(miniCartTotalPrice, { childList: true, subtree: true, attributes: true });

  if (cartTotalPrice) {
    observer.observe(cartTotalPrice, { childList: true, subtree: true, attributes: true });
  }
}

/**
 * The function `applyStickyStyleForFacetsContainer` sets a sticky position for a facets container
 * below a sticky header on a webpage.
 */
function applyStickyStyleForFacetsContainer() {
  const facetsContainer = document.querySelector('[data-facets-wrapper-type=drawer]');
  const stickyHeader = document.querySelector('.header-wrapper');
  const groupHeader = document.querySelector('.shopify-section-group-header-group.section-header');
  let isStickyHeader = false;

  if (facetsContainer && stickyHeader) {
    const updateStickyPosition = () => {
      setTimeout(() => {
        // Check if the sticky-header is the "sticky"
        if (stickyHeader && stickyHeader.dataset && 'stickyType' in stickyHeader.dataset) {
          isStickyHeader = true;
        }

        // Calculate the top position for the facets container
        const stickyHeaderHeight = stickyHeader.clientHeight;
        let topPosition = 0;

        if (!groupHeader.classList.contains('shopify-section-header-hidden') && isStickyHeader) {
          topPosition = stickyHeaderHeight;
        }

        // Set the top position of the facets container dynamically
        facetsContainer.style.top = `${topPosition}px`;
      }, 10);
    };

    // Update the position on page load
    updateStickyPosition();

    // Update the position when the window is resized
    window.addEventListener('resize', updateStickyPosition);

    // Handle scroll events
    window.addEventListener('scroll', () => {
      updateStickyPosition(); // Ensure the position is updated on scroll
    });

    // Make the facets container sticky
    facetsContainer.style.position = 'sticky';
  }
}

function updateStickyHeaderClassesOnHover() {
  try {
    const stickyHeader = document.querySelector('sticky-header.homepage-header.header-transparent');
    const stickyWrapper = stickyHeader && stickyHeader.closest('.shopify-section-header-sticky');
    const isSmallScreen = window.innerWidth < 989;
    const searchModalDesktopForm = document.querySelector('.search-modal__form.search-modal__form--desktop');
    const defaultColorScheme = stickyHeader ? stickyHeader.dataset.defaultColorScheme : '';
    const transparentColorScheme = stickyHeader ? stickyHeader.dataset.transparentColorScheme : '';

    if (stickyHeader && !isSmallScreen) {
      stickyHeader.addEventListener('mouseover', function () {
        if (document.body.classList.contains('overflow-hidden')) {
          return;
        }
        if (stickyHeader.classList.contains('predictive-search-focused')) return;
        if (transparentColorScheme && !stickyWrapper.classList.contains('scrolled-past-header')) {
          stickyHeader.classList.remove(transparentColorScheme);
        }
        stickyHeader.classList.remove('header-transparent');
        stickyHeader.classList.add('gradient', 'header-transparent-hover');
        if (defaultColorScheme && !stickyWrapper.classList.contains('scrolled-past-header')) {
          stickyHeader.classList.add(defaultColorScheme);
        }
      });
      stickyHeader.addEventListener('mouseout', function () {
        if (document.body.classList.contains('overflow-hidden')) {
          return;
        }
        if (stickyHeader.classList.contains('predictive-search-focused')) return;
        if (!searchModalDesktopForm || (searchModalDesktopForm && !searchModalDesktopForm.getAttribute('open'))) {
          stickyHeader.classList.remove('gradient', 'header-transparent-hover');
          if (defaultColorScheme && !stickyWrapper.classList.contains('scrolled-past-header')) {
            stickyHeader.classList.remove(defaultColorScheme);
          }
          stickyHeader.classList.add('header-transparent');
          if (transparentColorScheme && !stickyWrapper.classList.contains('scrolled-past-header')) {
            stickyHeader.classList.add(transparentColorScheme);
          }
        }
      });
    }
  } catch (e) {
    console.error('Error in updateStickyHeaderClassesOnHover:', e);
  }
}

/* Custom Handler to Refresh and Open Mini-cart in the Wishlist */
function wishlistAddToCartEvent() {
  document.querySelector('body').addEventListener('wishlistAddToCartEvent', (e) => {
    fetch(`${routes.cart_url}?section_id=cart-drawer`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const selectors = [
          { selector: '.cart-count-bubble', target: '.header .cart-count-bubble' },
          { selector: 'cart-drawer', target: 'cart-drawer' },
        ];
        for (const selector of selectors) {
          const targetElement = document.querySelector(selector.target);
          const sourceElement = html.querySelector(selector.selector);
          if (targetElement && sourceElement) {
            targetElement.replaceWith(sourceElement);
          }
        }
        document.querySelector('cart-drawer').open();
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        // Reinitialize wishlist event
        document.body.dispatchEvent(new CustomEvent('initTheWishlist'));
      });
  });
}

/* Snippet from WLC: JS to get and update count item wishlist */
function initEventForWishlistPDP() {
  let initPage = false;
  console.log('initEventForWishlistPDP ... ');
  const buttonsWishlistDetail = document.querySelectorAll('[data-btn-detail-wishlist]');
  const buttonMoveToWishlist = document.querySelectorAll('.move-to-wishlist');
  const buttonType = {
    LOADING: 'LOADING',
    TEXT: 'TEXT',
  };
  const iconLoading = `<svg class="icon-loading-wishlist" aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" width="1.25em" height="1.25em" xmlns="http://www.w3.org/2000/svg"><circle class="path" fill="none" stroke- width="6" cx="33" cy="33" r="30" style="stroke: #FFF;"></circle></svg>`;

  const iconAddedWishlist = `<svg class="icon icon-heart-filled" width="21" height="19" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 19">
    <path d="M18.38,3.12c.74,.72,1.12,1.63,1.12,2.71,0,.62-.13,1.24-.39,1.88-.27,.63-.73,1.36-1.41,2.18s-1.59,1.79-2.76,2.91c-1.16,1.12-2.64,2.46-4.44,4.02-1.8-1.58-3.28-2.92-4.44-4.03-1.17-1.11-2.09-2.08-2.76-2.9-.68-.82-1.14-1.55-1.41-2.18-.26-.64-.39-1.26-.39-1.88,0-1.08,.38-1.99,1.14-2.71,.75-.72,1.69-1.08,2.8-1.08,.89,0,1.72,.24,2.47,.73,.75,.48,1.43,1.23,2.04,2.23h1.1c.6-.99,1.28-1.73,2.03-2.22,.76-.5,1.59-.74,2.48-.74,1.13,0,2.06,.36,2.82,1.08Z"/><path d="M19.5,5.83c0-1.08-.38-1.99-1.12-2.71-.76-.72-1.69-1.08-2.82-1.08-.89,0-1.72,.24-2.48,.74-.75,.49-1.43,1.23-2.03,2.22h-1.1c-.61-1-1.29-1.75-2.04-2.23-.75-.49-1.58-.73-2.47-.73-1.11,0-2.05,.36-2.8,1.08-.76,.72-1.14,1.63-1.14,2.71,0,.62,.13,1.24,.39,1.88,.27,.63,.73,1.36,1.41,2.18,.67,.82,1.59,1.79,2.76,2.9,1.16,1.11,2.64,2.45,4.44,4.03,1.8-1.56,3.28-2.9,4.44-4.02,1.17-1.12,2.08-2.09,2.76-2.91s1.14-1.55,1.41-2.18c.26-.64,.39-1.26,.39-1.88Zm1.12,0c0,.72-.13,1.43-.41,2.14-.28,.72-.76,1.51-1.46,2.39-.69,.88-1.64,1.89-2.83,3.04s-2.72,2.53-4.57,4.15l-.85,.74-.85-.74c-1.84-1.62-3.36-3-4.56-4.15s-2.15-2.16-2.84-3.04c-.7-.88-1.18-1.67-1.46-2.39-.28-.71-.41-1.42-.41-2.14,0-1.38,.48-2.54,1.45-3.47,.98-.94,2.18-1.41,3.61-1.41,.99,0,1.92,.25,2.78,.74,.87,.48,1.63,1.19,2.28,2.12,.65-.93,1.41-1.64,2.28-2.12,.86-.49,1.79-.74,2.78-.74,1.43,0,2.63,.47,3.61,1.41,.97,.93,1.45,2.09,1.45,3.47Z"/></svg>`;

  const iconAddWishlist = `<svg class="icon icon-heart"  width="21" height="19" viewBox="0 0 21 19" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10.5 18.2915L9.64753 17.55C7.81153 15.9347 6.29278 14.5521 5.09128 13.4021C3.88997 12.252 2.94169 11.2377 2.24644 10.3593C1.55119 9.48093 1.06547 8.68612 0.789281 7.97491C0.513094 7.26389 0.375 6.54862 0.375 5.8291C0.375 4.45128 0.861094 3.29437 1.83328 2.35837C2.80528 1.42219 4.00669 0.954102 5.4375 0.954102C6.42694 0.954102 7.35506 1.19785 8.22187 1.68535C9.08869 2.17285 9.84806 2.88189 10.5 3.81248C11.1519 2.88189 11.9113 2.17285 12.7781 1.68535C13.6449 1.19785 14.5731 0.954102 15.5625 0.954102C16.9933 0.954102 18.1947 1.42219 19.1667 2.35837C20.1389 3.29437 20.625 4.45128 20.625 5.8291C20.625 6.54862 20.4869 7.26389 20.2107 7.97491C19.9345 8.68612 19.4488 9.48093 18.7536 10.3593C18.0583 11.2377 17.1136 12.252 15.9194 13.4021C14.7252 14.5521 13.2029 15.9347 11.3525 17.55L10.5 18.2915ZM10.5 16.8249C12.3 15.2583 13.7812 13.9163 14.9437 12.799C16.1062 11.6815 17.025 10.712 17.7 9.89052C18.375 9.06899 18.8438 8.34126 19.1062 7.70733C19.3687 7.07322 19.5 6.44714 19.5 5.8291C19.5 4.74577 19.125 3.84299 18.375 3.12077C17.625 2.39855 16.6875 2.03743 15.5625 2.03743C14.6668 2.03743 13.8404 2.28362 13.0833 2.776C12.326 3.26837 11.6481 4.00964 11.0496 4.99981H9.95044C9.3375 3.99574 8.65603 3.25095 7.90603 2.76544C7.15603 2.2801 6.33319 2.03743 5.4375 2.03743C4.32694 2.03743 3.393 2.39855 2.63569 3.12077C1.87856 3.84299 1.5 4.74577 1.5 5.8291C1.5 6.44714 1.63125 7.07322 1.89375 7.70733C2.15625 8.34126 2.625 9.06899 3.3 9.89052C3.975 10.712 4.89375 11.678 6.05625 12.7884C7.21875 13.8989 8.7 15.2444 10.5 16.8249Z" fill="currentColor"/>
        </svg>`;

  function getVariantId() {
    const hiddenInput = document.querySelector('.product-form input[name="id"]');
    if (!hiddenInput) {
      console.log('Please, contact developer theme to querySelector exactly the input of variant');
      return;
    }
    const variantId = hiddenInput.value;
    if (variantId) {
      return variantId;
    } else {
      console.log('Can not get variant id');
      return null;
    }
  }

  function removeDisableButton() {
    const elButtons = document.querySelectorAll('.detail-add-wishlist-wrapper .btn-wishlist.disable');
    if (elButtons) {
      elButtons.forEach((button) => {
        button.classList.remove('disable');
      });
    }
  }

  function renderButton(type) {
    const buttonIcons = document.querySelectorAll('.detail-add-wishlist-wrapper .button-icon');
    const buttonTexts = document.querySelectorAll('.detail-add-wishlist-wrapper .button-text');
    if (type === buttonType.LOADING) {
      buttonIcons.forEach((button) => (button.innerHTML = iconLoading));
    } else {
      const variantId = getVariantId();
      const checkItemInWishlist = theWishlist.checkVariantInWishlist(variantId);
      if (checkItemInWishlist) {
        buttonIcons.forEach((button) => (button.innerHTML = iconAddedWishlist));
        buttonTexts.forEach((button) => (button.innerHTML = 'Added To Wishlist'));
      } else {
        buttonIcons.forEach((button) => (button.innerHTML = iconAddWishlist));
        buttonTexts.forEach((button) => (button.innerHTML = 'Add To Wishlist'));
      }
    }
  }

  function actionButtonWishlist() {
    buttonsWishlistDetail.forEach((button) => {
      button.addEventListener('click', function () {
        const variantId = getVariantId();
        const checkItemInWishlist = theWishlist.checkVariantInWishlist(variantId);
        if (variantId) {
          renderButton(buttonType.LOADING);
          if (checkItemInWishlist) {
            theWishlist.removeWishlistGeneral(variantId, 'DETAIL_PAGE', function (res) {
              console.log(res);
            });
          } else {
            theWishlist.addWishlistGeneral(variantId, 'DETAIL_PAGE', function (res) {
              console.log(res);
            });
          }
        }
      });
    });

    buttonMoveToWishlist.forEach((button) => {
      button.addEventListener('click', function () {
        const wishlistButton = this.parentNode.querySelector('.button-collection-wishlist');
        if (wishlistButton) {
          wishlistButton.dispatchEvent(new Event('click'));
        }
      });
    });
  }
  function handleChangeVariant() {
    const hiddenInput = document.querySelector('.product-form input[name="id"]');
    hiddenInput &&
      hiddenInput.addEventListener('change', function (event) {
        renderButton(buttonType.TEXT);
      });
  }

  document.body.addEventListener('initTheWishlist', () => {
    console.log('initTheWishlist ... ');
    if (!initPage) {
      initPage = true;
      removeDisableButton();
      actionButtonWishlist();
      handleChangeVariant();
    }
    renderButton(buttonType.TEXT);
  });
}

function initFunctionReinitRatingWidgetGlobal() {
  if (!window.triggerReinitRatingRecommendationAfterAjax) {
    window.triggerReinitRatingRecommendationAfterAjax = () => {
      const widgetElements = document.querySelectorAll('[data-oke-star-rating]');
      if (widgetElements.length) {
        widgetElements.forEach((element) => {
          window.okeWidgetApi && window.okeWidgetApi.initWidget(element, true);
        });
      }
    };
  }
}

// Create a global function to initialize the wishlist on product recommendations
// Create as global function that can be called from other scripts
// Function is supported by WLC
window.initWishlistOnProductRecommendations = (container) => {
  if (!container) return;
  let hasDispatched = false;

  function tryDispatch() {
    if (hasDispatched) return;

    const wishlistButtons = container.querySelectorAll('.wrapper-button-collection');
    if (wishlistButtons.length > 0) {
      console.log('Wishlist buttons found, dispatching initTheWishlist');
      document.body.dispatchEvent(new CustomEvent('initTheWishlist'));
      hasDispatched = true;
    }
  }

  tryDispatch();

  const interval = setInterval(() => {
    tryDispatch();
    if (hasDispatched) clearInterval(interval);
  }, 500);

  if (container) {
    const observer = new MutationObserver(() => {
      tryDispatch();
    });
    observer.observe(container, { childList: true, subtree: true });
  }

  document.addEventListener('shopify:section:load', () => {
    tryDispatch();
  });
};

// Function is supported from WLC
function initEventForWishlistInQuickAddModal() {
  // Dispatch wishlist on quick modal open
  const quickAddModalObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (
        mutation.type === 'attributes' &&
        mutation.attributeName === 'open' &&
        mutation.target.matches('quick-add-modal[open]')
      ) {
        document.body.dispatchEvent(new CustomEvent('initTheWishlist'));
      }
    });
  });

  document.querySelectorAll('quick-add-modal').forEach((modal) => {
    quickAddModalObserver.observe(modal, { attributes: true });
  });

  const dynamicModalObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.tagName === 'QUICK-ADD-MODAL') {
          quickAddModalObserver.observe(node, { attributes: true });
        }
      });
    });
  });

  dynamicModalObserver.observe(document.body, { childList: true, subtree: true });
}

// Script support from WLC to handle wishlist in the mini cart
function itniEventForWishlistInFlyoutCart() {
  document.addEventListener('click', function (e) {
    const button = e.target.closest('.button-collection-wishlist');
    if (!button) return;

    const cartItem = button.closest('.cart-item');
    if (!cartItem) return;

    // Delay to wait for modal to be rendered (adjust time if needed)
    setTimeout(() => {
      const modal = document.querySelector('.modal-root.osc-css'); // update to actual modal class/ID
      if (!modal) return;

      // Loop through all properties in the clicked cart item
      const properties = cartItem.querySelectorAll('.product-option');
      properties.forEach((option) => {
        const propertyName = option.getAttribute('data-property');
        const propertyValue = option.getAttribute('data-property-value');

        if (propertyName && propertyValue) {
          // Find matching input in modal and click it
          const input = modal.querySelector(
            `input.variant-item-input[name="${propertyName}"][value="${propertyValue}"]`
          );
          if (input) input.click();
        }
      });
    }, 100); // Adjust delay if modal loads slower
  });
}

// Reinitialize the sticky facet after SearchSpring loads
function reinitStickyFacetAfterSSLoad() {
  window.addEventListener('searchspring.domReady', function (event) {
    applyStickyStyleForFacetsContainer();
  });
}

// Run the function when the DOM is ready
document.addEventListener('DOMContentLoaded', function () {
  reinitStickyFacetAfterSSLoad();
  toggleFocusSearch();
  toggleMegaMenuWhenHover();
  addEventForMegaMenuItem();
  forceFooterMenuOpenOnDesktop();
  initProcessBar();
  checkIfTotalPriceChange();
  applyStickyStyleForFacetsContainer();
  updateStickyHeaderClassesOnHover();
  wishlistAddToCartEvent();
  initEventForWishlistPDP();
  initFunctionReinitRatingWidgetGlobal();
  initEventForWishlistInQuickAddModal();
  itniEventForWishlistInFlyoutCart();

  window.addEventListener('resize', handleResize);
});
